import React from 'react';

import { Grid, Typography } from '@mui/material';
import makeStyles from '@mui/styles/makeStyles';
import { useIntl } from 'react-intl';
import SquareIcon from '@mui/icons-material/Square';

const useStyles = makeStyles((theme) => ({
  legendText: {
    color: theme.palette.text.secondary
  },
  legendIconSkeleton: {
    width: theme.spacing(1.5),
    height: theme.spacing(1.5),
    marginRight: theme.spacing(0.4),
    color: theme.palette.grey[300]
  },
  skeletonBox: {
    display: 'flex',
    paddingLeft: theme.spacing(3),
    alignItems: 'center'
  }
}));

const HeaderNoData = () => {
  const classes = useStyles();
  const { formatMessage } = useIntl();

  return (
    <Grid container item xs={6.5} justifyContent={'flex-end'}>
      {Array.from(new Array(3)).map((_, i) => (
        <Grid key={i} item className={classes.skeletonBox}>
          <SquareIcon fontSize="small" className={classes.legendIconSkeleton} />

          <Typography variant="caption" className={classes.legendText}>
            {formatMessage({ id: 'insights.timeSheetLabels.na' })}
          </Typography>
        </Grid>
      ))}
    </Grid>
  );
};
export default React.memo(HeaderNoData);
